import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { componentToRx } from "react-rxk";
import { fa } from "typed-font-awesome";

import { CotizacionView } from "../../guias/documentacion/componentes/guias/cotizacionview";
import { obtenerCotizacionDeCotizacionModelDTO } from "./logic";
import { Paso } from "../paso"; 7

type Entity = models.CotizadorModelDTO;

class VerCotizacionNoRx extends React.PureComponent<{ value?: Entity }> {
    render() {
        const { value } = this.props;
        const total = value && value.ImportesGuia.Total
        const title =
            <span>
                Vea su cotización
                {!!total && <b>{" ("}{kea.formatCurrency(total)})</b>}
            </span>;
        return (
            <div>
                <Paso paso={3} title={title} done={!!(value && value.ImportesGuia.Total > 0)} />

                <div className="row">
                    <div className="col-md-6">
                        {value && <CotizacionView value={obtenerCotizacionDeCotizacionModelDTO(value)} />}
                    </div>
                </div>
            </div>);
    }
}

export const VerCotizacion = componentToRx(VerCotizacionNoRx);


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/cotizador/ver/component.tsx